export default "__VITE_ASSET__DZdP_ngA__"